// test1073
(1073 && 0);
